import { GameMode } from "../../api/types";
import type { ModeRules } from "../../api/types";
import { formatClock } from "../format";

/** One-line pitch per mode (docs/DESIGN.md "Game modes"). */
export const MODE_BLURBS: Readonly<Record<GameMode, string>> = {
  [GameMode.UNSPECIFIED]: "",
  [GameMode.FFA]: "Every player for themselves. Spawns keep you away from enemies.",
  [GameMode.TDM]: "Two teams, one kill count. Fast fights, short respawns.",
  [GameMode.KOTH]: "Hold the rotating hill. A contested hill scores nothing.",
  [GameMode.DEFUSAL]: "Plant or defuse. One life per round, no respawns.",
};

/** Compact rules summary, e.g. "6v6 · first to 75 kills · 10:00". */
export function describeRules(rules: ModeRules): string {
  const teams = rules.teamSize > 0 ? `${rules.teamSize}v${rules.teamSize}` : `${rules.maxPlayers} players`;
  switch (rules.mode) {
    case GameMode.FFA:
    case GameMode.TDM:
      return `${teams} · first to ${rules.scoreLimit} kills · ${formatClock(rules.timeLimitSec)}`;
    case GameMode.KOTH:
      return `${teams} · first to ${rules.scoreLimit} points · ${formatClock(rules.timeLimitSec)}`;
    case GameMode.DEFUSAL:
      return `${teams} · first to ${rules.roundsToWin} rounds · ${formatClock(rules.roundTimeSec)} per round`;
    default:
      return teams;
  }
}
